import React, { useEffect, useState } from 'react'
import { faAngleLeft, faAngleRight, faArrowDownShortWide, faArrowUpWideShort, faFilter, faFolderOpen } from '@fortawesome/free-solid-svg-icons';
import PickColumnsModal from "../../../../components/modals/SeriveModals/AllServiceModals/PickColumnsModal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BulkMoveToTrending, BulkRemoveFromTrending, BulkStatusUpdate } from '../../../../services/ProductService/AllProductList/AllProductServices';
import StatusChangeModal from '../../../../components/modals/SeriveModals/AllServiceModals/StatusChageModal';
import MoveToTrendingPopup from '../../../../components/modals/SeriveModals/AllServiceModals/MoveToTrendingPopUp';
import BulkEditModal from '../../../../components/modals/SeriveModals/AllServiceModals/BulkEditModal';
import ExportSelectedColumn from '../../../../components/modals/SeriveModals/AllServiceModals/ExportSelectedColumn';
import ExportRfqSelectedColumn from '../../../../components/modals/SeriveModals/AllServiceModals/ExportRfqSelectedColumn';
import BulkAddTagsPopup from '../../../../components/modals/SeriveModals/AllServiceModals/BulkAddTagsPopup';
import BulkAssignedTo from '../../../../components/modals/SeriveModals/AllServiceModals/BulkAssignedTo';
import CreatedOn from '../../../../components/modals/SeriveModals/AllServiceModals/CreatedOn';
import AddGroupPopup from './AddGroupPopUp';
import TrendingAddGroupPopup from './AddGroupTrendingPopup';
import FilterPopup from './FilterPopUp';
import DeleteConfirmationPopup from './DeleteConfirmationPopup';
import FilterTrendingPopup from './FilterTrendingPopup';
import PickRfqColumnsModal from './PickRfqColumnModal';

export default function AllServicesActionsSection ({ onSelectColumns,
    onSelectedIds, onRfqSelectedIds,
    onSuccess,
    onColumnSearch, onRfqColumnSearch,
    onGroupByResponse, onRemoveGroupBy,
    onTrendingGroupByResponse, onTrendingRemoveGroupBy,
    onActionsModify,
    onChangeIcon,
    onFilteredData, onRemoveFilters,
    onTrendingFilteredData, onTrendingRemoveFilters }) {

    const [isAscending, setIsAscending] = useState(true);
    const [showPickColumn, setShowPickColumn] = useState(false);
    const [showActions, setShowActions] = useState(false);
    const [showStatusOptions, setShowStatusOptions] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [showTrendingPopup, setShowTrendingPopup] = useState(false);
    const [showBulkEdit, setShowBulkEdit] = useState(false);
    const [showBulkSelectedExport, setShowBulkSelectedExport] = useState(false);
    const [showBulkSelectedRfqExport, setShowBulkSelectedRfqExport] = useState(false);
    const [showBulkAddTags, setShowBulkAddTags] = useState(false);
    const [showBulkDeletePopup, setShowBulkDeletePopup] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState("");
    const [columnSearch, setColumnSearch] = useState("");
    const [rfqcolumnSearch, setRfqColumnSearch] = useState("");
    const [selectedmoving, setSelectedMoving] = useState("");

    const handleChangeOrder = () => {
        setIsAscending((prev) => !prev);
    };

    const handleBulkStatusUpdate = async (status) => {
        if (onSelectedIds.length === 0) return;

        const data = { product_ids: onSelectedIds, status: status === "Activate" };

        try {
            await BulkStatusUpdate('POST', data);
            setShowStatusOptions(false)
            onSuccess()
        } catch (error) {
            console.error("Error updating status:", error);
        }
    };

    const handleBulkMoveToTrending = async (status) => {
        if (onSelectedIds.length === 0) return;

        const data = { p_ids: onSelectedIds, };

        if (selectedmoving === 'Trending') {
            try {
                await BulkMoveToTrending('POST', data);
                setShowStatusOptions(false)
                onSuccess()
            } catch (error) {
                console.error("Error updating status:", error);
            }
        } else {
            try {
                await BulkRemoveFromTrending('POST', data);
                setShowStatusOptions(false)
                onSuccess()
            } catch (error) {
                console.error("Error updating status:", error);
            }
        }


    };

    const handleStatusChange = (status) => {
        setSelectedStatus(status);
        setModalOpen(true);
    };

    const confirmChange = () => {
        handleBulkStatusUpdate(selectedStatus);
        setModalOpen(false);
    };

    const handleMoveToTrending = () => {
        const newStatus = onActionsModify === 'all' ? 'Trending' : 'Not Trending';
        setSelectedMoving(newStatus);
        setShowTrendingPopup(true);
    };

    const confirmMoveToTrending = () => {
        handleBulkMoveToTrending(selectedmoving); // Now it depends on button content
        setShowTrendingPopup(false);
    };


    const handleRemoveGroupBy = () => {
        onRemoveGroupBy(false)
    }

    const handleTrendingRemoveGroupBy = () => {
        onTrendingRemoveGroupBy(false)
    }

    const handleAddGroupResponse = (response) => {
        onGroupByResponse(response)
    }

    const handleAddTrendingGroupResponse = (response) => {
        onTrendingGroupByResponse(response)
    }

    const handleSuccess = () => {
        onSuccess()
    }

    useEffect(() => {
        if (onSelectedIds.length === 0) {
            setShowActions(false);
        }
    }, [onSelectedIds]);

    useEffect(() => {
        if (onRfqSelectedIds.length === 0) {
            setShowActions(false);
        }
    }, [onRfqSelectedIds]);

    useEffect(() => {
        if (columnSearch) {
            onColumnSearch(columnSearch)
        }
    }, [columnSearch]);

    useEffect(() => {
        if (rfqcolumnSearch) {
            onRfqColumnSearch(rfqcolumnSearch)
        }
    }, [rfqcolumnSearch]);

    const style = "font-normal py-1 text-left px-3 hover:bg-gray-200"

    return (
        <div>
            <div className={`border border-gray-300 flex items-center justify-between py-3 mx-7 bg-gray-50 rounded-t-xl ${onChangeIcon === 'Edit'? 'opacity-50 cursor-not-allowed' : 'opacity-100 cursor-pointer'}`}>
                <div className='flex items-center justify-between gap-5 pl-10'>
                    {/* Search Input */}
                    {onActionsModify === 'highDemand' ? (
                        <div className="relative">
                            <input type="search" id="product-search" className="block py-1 px-2 w-60 z-20 rounded-xl border border-gray-300 outline-none border-r-0" placeholder='Search'
                                onChange={(e) => setRfqColumnSearch(e.target.value)} />
                            <button type="submit" className="absolute top-0 end-0 h-full p-2 text-gray-500 bg-white border-gray-300 rounded-e-xl border border-l-0">
                                <svg className="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                                </svg>
                            </button>
                        </div>
                    ) :
                        <div className="relative">
                            <input type="search" id="product-search" className="block py-1 px-2 w-60 z-20 rounded-xl border border-gray-300 outline-none border-r-0" placeholder='Search'
                                onChange={(e) => setColumnSearch(e.target.value)} />
                            <button type="submit" className="absolute top-0 end-0 h-full p-2 text-gray-500 bg-white border-gray-300 rounded-e-xl border border-l-0">
                                <svg className="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                                </svg>
                            </button>
                        </div>}

                    {/* Pick Column Button */}
                    <div
                        className={`px-3 py-1 bg-gray-200 rounded-lg text-gray-500 ${onChangeIcon === 'Edit'? 'opacity-50 cursor-not-allowed' : 'opacity-100 cursor-pointer'} hover:text-black`}
                        onClick={() => setShowPickColumn(true)}
                    >
                        Pick Column
                    </div>
                </div>

                {/* Right Side Controls */}
                <div className='flex items-center justify-between gap-10 px-5'>
                    <div className=" relative w-fit">
                        {onActionsModify === 'highDemand' ?
                        (<>
                        {onRfqSelectedIds.length > 0 && (
                            <div
                                className={`px-3 py-1 bg-gray-200 rounded-lg text-gray-500 ${onChangeIcon === 'Edit'? 'opacity-50 cursor-not-allowed' : 'opacity-100 cursor-pointer'} group`}
                                onClick={() => setShowActions(!showActions)}
                            >
                                <p className='group-hover:text-black'>Action</p>
                            </div>
                        )}
                        </>)
                        :
                        (<>
                        {onSelectedIds.length > 0 && (
                            <div
                                className={`px-3 py-1 bg-gray-200 rounded-lg text-gray-500 ${onChangeIcon === 'Edit'? 'opacity-50 cursor-not-allowed' : 'opacity-100 cursor-pointer'} group`}
                                onClick={() => setShowActions(!showActions)}
                            >
                                <p className='group-hover:text-black'>Action</p>
                            </div>
                        )}
                        </>)}
                        
                        {showActions && <div className={`flex flex-col bg-[#fff]  rounded shadow-lg text-[#000] text-left absolute top-[35px] lg:top-[50px] lg:left-[0px] w-[250px] `}>
                            <div className="relative">
                                <div className="flex flex-col p-3 gap-3">
                                    {onActionsModify === 'highDemand' ?
                                        (<>
                                            <button className={style} onClick={() => setShowBulkSelectedRfqExport(true)}>Export Selected</button>
                                        </>)
                                        : 
                                        (<>
                                            <button className={style}
                                                onClick={() => setShowBulkEdit(true)}>Bulk Edit</button>
                                            {/* Status Button - Toggles Submenu */}
                                            <div className="relative">
                                                <button
                                                    className="font-normal py-1 px-3 w-full text-left hover:bg-gray-200 flex justify-between items-center "
                                                    onClick={() => setShowStatusOptions(!showStatusOptions)}
                                                >
                                                    <p>Status </p> <FontAwesomeIcon icon={showStatusOptions ? faAngleLeft : faAngleRight} />
                                                </button>
                                                {showStatusOptions && (
                                                    <div className="absolute top-0 left-full bg-gray-100 shadow-md rounded-lg w-32 p-3 gap-3 border">
                                                        <button onClick={() => handleStatusChange("Activate")} className="block px-3 py-1 hover:bg-green-200 hover:text-green-600 w-full rounded-lg">
                                                            Activate
                                                        </button>
                                                        <button onClick={() => handleStatusChange("Deactivate")} className="block px-3 py-1 hover:bg-red-200 hover:text-red-600 w-full rounded-lg">
                                                            Deactivate
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                            <button className={style} onClick={handleMoveToTrending}>
                                                {onActionsModify === 'all' ? 'Moved to Trending Products' : 'Removed from Trending Products'}
                                            </button>
                                            <button className={style} onClick={() => setShowBulkSelectedExport(true)}>Export Selected</button>
                                            <button> <BulkAssignedTo onSelectedIds={onSelectedIds} onSuccess={handleSuccess} /> </button>
                                            <button className={style} onClick={() => setShowBulkAddTags(true)}>Add Tags</button>
                                            <button className={style}>Email to Selected Product Owener's</button>
                                            <button className={style}>SMS to Selected Product Owener's</button>
                                            <button className={style}>Whatsapp Message to Product Owener's</button>
                                            <button className={style} onClick={() => setShowBulkDeletePopup(true)}>Delete</button>
                                        </>)
                                        }
                                </div>
                            </div>
                        </div>}
                    </div>

                    {onActionsModify !== 'highDemand' && (<>
                        <div className={`px-3 py-1 bg-gray-200 rounded-lg text-gray-500 ${onChangeIcon === 'Edit'? 'opacity-50 cursor-not-allowed' : 'opacity-100 cursor-pointer'} group flex items-center gap-2`}>
                            <FontAwesomeIcon icon={faFilter} />
                            {onActionsModify === 'all' ? (<FilterPopup onFilteredData={onFilteredData} onRemoveFilters={onRemoveFilters} />) :
                                (<FilterTrendingPopup onTrendingFilteredData={onTrendingFilteredData} onTrendingRemoveFilters={onTrendingRemoveFilters} />)}
                        </div>
                        <div className={`px-3 py-1 bg-gray-200 rounded-lg text-gray-500 ${onChangeIcon === 'Edit'? 'opacity-50 cursor-not-allowed' : 'opacity-100 cursor-pointer'} group flex items-center gap-2`}>
                            <FontAwesomeIcon icon={faFolderOpen} />
                            {onActionsModify === 'all' ? (<AddGroupPopup onResponse={handleAddGroupResponse} onRemoveGroupBy={handleRemoveGroupBy} />) :
                                (<TrendingAddGroupPopup onTrendingResponse={handleAddTrendingGroupResponse} onTrendingRemoveGroupBy={handleTrendingRemoveGroupBy} />)}
                        </div>
                    </>)}

                    <div
                        className={`px-3 py-1 bg-gray-200 rounded-lg text-gray-500 ${onChangeIcon === 'Edit'? 'opacity-50 cursor-not-allowed' : 'opacity-100 cursor-pointer'} flex items-center gap-1`}>
                        <FontAwesomeIcon onClick={handleChangeOrder} icon={isAscending ? faArrowDownShortWide : faArrowUpWideShort} />
                        <p>|</p>
                        <p className='hover:text-black'>
                            <CreatedOn />
                        </p>
                    </div>
                </div>
            </div>

            {/* ✅ Pass selected columns to parent */}
            {showPickColumn && (<> {
                onActionsModify === 'highDemand' ? (
                    <>
                        <PickRfqColumnsModal onRfqSelectColumns={onSelectColumns}
                            onRfqClose={() => setShowPickColumn(false)} />
                    </>) : (
                    <PickColumnsModal
                        onSelectColumns={onSelectColumns}
                        onClose={() => setShowPickColumn(false)}
                    />)
            }
            </>

            )}
            {/* Status Change Modal */}
            <StatusChangeModal
                isOpen={modalOpen}
                onClose={() => { setModalOpen(false); setShowActions(false); onSuccess() }}
                onConfirm={confirmChange}
                status={selectedStatus}
            />
            {/* Status Change Modal */}
            <MoveToTrendingPopup
                isOpen={showTrendingPopup}
                onSelectedAction={selectedmoving}
                onClose={() => { setShowTrendingPopup(false); setShowActions(false); onSuccess() }}
                onConfirm={confirmMoveToTrending} // Your API call or logic
            />
            <BulkEditModal isOpen={showBulkEdit} onClose={() => { setShowBulkEdit(false); setShowActions(false); onSuccess() }} onSelectedIds={onSelectedIds} />
            {showBulkSelectedExport && (<ExportSelectedColumn onClose={() => { setShowBulkSelectedExport(false); setShowActions(false); onSuccess() }} onSelectedId={onSelectedIds} />)}
            {showBulkSelectedRfqExport && (<ExportRfqSelectedColumn onClose={() => { setShowBulkSelectedRfqExport(false); setShowActions(false); onSuccess() }} onRfqSelectedId={onRfqSelectedIds} />)}
            {showBulkAddTags && (<BulkAddTagsPopup onClose={() => { setShowBulkAddTags(false); setShowActions(false); onSuccess() }} onSelectedId={onSelectedIds} />)}
            {showBulkDeletePopup && (<DeleteConfirmationPopup onClose={() => { setShowBulkDeletePopup(false); setShowActions(false); onSuccess() }} onSelectedId={onSelectedIds}
                onConfirm={() => { setModalOpen(false); setShowStatusOptions(false) }} />)}
        </div>
    )
}